/* ============================================================
   NOMADI CART OVERHAUL - Interactive JavaScript
   Features: Shipping bar animation, financing calc, upsell ATC
   ============================================================ */

(function() {
  'use strict';

  // Configuration
  const FREE_SHIPPING_THRESHOLD = 3500; // in dollars (matches theme settings)
  const AFFIRM_MONTHS = 12;

  // ---- FREE SHIPPING BAR ----
  function updateShippingBar() {
    const bar = document.querySelector('.nomadi-shipping-bar');
    if (!bar) return;

    const totalCents = parseInt(bar.dataset.cartTotal || '0', 10);
    const totalDollars = totalCents / 100;
    const thresholdDollars = FREE_SHIPPING_THRESHOLD;
    const percentage = Math.min((totalDollars / thresholdDollars) * 100, 100);
    const remaining = Math.max(thresholdDollars - totalDollars, 0);

    // Update progress bar
    const fill = bar.querySelector('.nomadi-shipping-bar__fill');
    const text = bar.querySelector('.nomadi-shipping-bar__text');

    if (fill) {
      fill.style.width = percentage + '%';
    }

    if (text) {
      if (remaining <= 0) {
        text.innerHTML = '🎉 <strong>Congratulations!</strong> You\'ve unlocked <span>FREE shipping!</span>';
        bar.classList.add('qualified');
      } else {
        const formattedRemaining = '$' + remaining.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        text.innerHTML = '🚚 You\'re <span>' + formattedRemaining + '</span> away from <strong>FREE shipping!</strong>';
        bar.classList.remove('qualified');
      }
    }
  }

  // ---- FINANCING CALCULATOR ----
  function updateFinancingCTA() {
    const cta = document.querySelector('.nomadi-finance-cta');
    if (!cta) return;

    const totalCents = parseInt(cta.dataset.cartTotal || '0', 10);
    const totalDollars = totalCents / 100;
    const monthlyPayment = (totalDollars / AFFIRM_MONTHS).toFixed(0);

    const amountEl = cta.querySelector('.nomadi-finance-cta__amount');
    if (amountEl && totalDollars > 0) {
      amountEl.textContent = '$' + monthlyPayment + '/mo';
    }

    const subtitleEl = cta.querySelector('.nomadi-finance-cta__subtitle');
    if (subtitleEl && totalDollars > 0) {
      subtitleEl.innerHTML = 'Pay as low as <span class="nomadi-finance-cta__amount">$' + monthlyPayment + '/mo</span> with Affirm or split into 4 with Shop Pay';
    }
  }

  // ---- UPSELL ADD TO CART ----
  function initUpsellButtons() {
    document.querySelectorAll('.nomadi-upsell-card__add').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = this.dataset.variantId;
        if (!variantId) return;

        var originalText = this.textContent;
        this.textContent = 'Adding...';
        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        })
        .then(function(response) { return response.json(); })
        .then(function() {
          btn.textContent = '✓ Added!';
          btn.style.background = '#4caf50';
          btn.style.borderColor = '#4caf50';
          btn.style.color = '#fff';
          setTimeout(function() { window.location.reload(); }, 800);
        })
        .catch(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        });
      });
    });
  }

  // ---- CONFETTI EFFECT ----
  function createConfetti(container) {
    if (!container || container.dataset.confettiDone === 'true') return;
    container.dataset.confettiDone = 'true';

    var colors = ['#b8860b', '#4caf50', '#2196f3', '#ff9800', '#9c27b0'];
    for (var i = 0; i < 20; i++) {
      var confetti = document.createElement('div');
      confetti.style.cssText = 'position:absolute;width:6px;height:6px;border-radius:50%;top:50%;left:' + (Math.random() * 100) + '%;background:' + colors[Math.floor(Math.random() * colors.length)] + ';animation:confettiFall ' + (0.8 + Math.random() * 0.4) + 's ease-out forwards;opacity:0;';
      container.appendChild(confetti);
    }
  }

  // Add confetti keyframes
  var style = document.createElement('style');
  style.textContent = '@keyframes confettiFall{0%{opacity:1;transform:translateY(0) rotate(0deg)}100%{opacity:0;transform:translateY(-30px) rotate(' + (Math.random() > 0.5 ? '' : '-') + '180deg) translateX(' + (Math.random() * 40 - 20) + 'px)}}';
  document.head.appendChild(style);

  // ---- INITIALIZATION ----
  function init() {
    updateShippingBar();
    updateFinancingCTA();
    initUpsellButtons();

    // Check if qualified for confetti
    var bar = document.querySelector('.nomadi-shipping-bar');
    if (bar && bar.classList.contains('qualified')) {
      var confettiContainer = bar.querySelector('.nomadi-shipping-bar__confetti');
      if (confettiContainer) {
        setTimeout(function() { createConfetti(confettiContainer); }, 500);
      }
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also listen for Shopify cart updates (AJAX cart)
  document.addEventListener('cart:updated', function() {
    setTimeout(function() {
      updateShippingBar();
      updateFinancingCTA();
    }, 100);
  });

})();
